module.exports = __webpack_public_path__ + "img/logoHV.8f996d58.jpg";